import React from 'react';
import { CosmosText } from '../../../cosmos/web-scoped/react';
import { Placeholder } from '../../Placeholder';
import { CountryFlag } from '../../../Utils/flags';
import { capitalize } from '../../../Utils/string';

import './ProfileMeta.scss';

export const ProfileMeta = ({ athlete }) => {
  return (
    <div>
      {athlete.athlete_id ? (
        <>
          <div className={`mb-3`}>
            <img
              className="flag"
              src={CountryFlag(athlete.nationality)}
              alt={athlete.nationality} />
            <CosmosText class="profile-nationality">{athlete.nationality}</CosmosText>
          </div>
          <div>
            <CosmosText class="profile-name" weight="medium" size="large">
              {capitalize(athlete.first_name || '-')}<br />
              {capitalize(athlete.last_name || '-')}
            </CosmosText>
          </div>
        </>
      ) : (
        <>
          <Placeholder tag="p" maxWidth="23px" height="17px" margin="0 0 14px 0" />
          <Placeholder tag="p" maxWidth="165px" height="12px" />
          <Placeholder tag="p" maxWidth="165px" height="12px" />
          <Placeholder tag="p" maxWidth="165px" height="12px" />
        </>
      )}
    </div>
  );
};
